import {Injectable} from '@angular/core';

/**
 * Handles modal interactions.
 */
@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  public modalOpened: boolean = false;
  public clubAssignment: boolean = false;

  constructor() {
  }

  /**
   * Set the status of the edit customer modal.
   */
  public toggleModal(status: boolean): void {
    this.clubAssignment = false;
    this.modalOpened = status;
  }

  /**
   * Set the status of the club-overview assignment workspace.
   */
  public toggleClubAssignment(status: boolean): void {
    this.modalOpened = false;
    this.clubAssignment = status;
  }

}
